/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: breakprepostroll-resource-factory.js
 *
 * Created by Phil I think
 */

'use strict';

angular
.module('prism-ui.components')
.factory('BreakPrePostRollResourceFactory', ($resource, EndPointService) => {
	return $resource(
	    `${EndPointService.breakPrePostRollEndpoint}/:containerId`,
        {},
		{

		    //===============//
		    // Container API //
            //===============//

			update: {
				method: 'PUT'
			},


            //================================//
            // Break Pre/post Roll Couple API //
            //================================//

            //
            // Ordinary branding asset containers have assets,
            // and accordingly the container API includes a
            // separate CRUD API for those assets.
            //
            // Break pre/post roll containers have break pre/post
            // roll coupling objects, simply known as "break
            // pre/post rolls". These coupling objects each have a
            // preroll and a postroll asset.
            //
            // Those discrete assets are managed using the
            // ordinary pre/post roll API, but API calls for
            // managing the break pre/post roll coupling objects
            // are here.
            //

            //
            // Note!
            //
            //      There's a key difference from other branding
            //      asset resources, in that there is no `/assets`
            //      endpoint path.
            //
            //      Rather, POSTing to a break pre/post roll
            //      container _itself_ creates the coupling object,
            //      while updates are handled by the
            //      `breakPrePostRolls/:breakPrePostRollId`
            //      endpoint.
            //

            createAsset: {
			    // this is a synonym for the default 'save' action
			    method: 'POST',
            },
			updateAsset: {
				method: 'PUT',
				url: `${EndPointService.breakPrePostRollEndpoint}/breakPrePostRolls/:assetId`
			}
		});
});
